import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import * as _ from 'lodash';

import GlobalLayout from 'Layouts/Global.layout';

import { Container, Text, Icon, Button } from 'UILib';
import {
  genericComponentTimer,
  transformBalance
} from 'Utils/Helpers/component.helpers';
import { WITHDRAW_TYPE } from 'Constants/Withdraw/Withdraw.constants';
import { APP_ROUTES } from 'Constants/GlobalConstants/Global.constants';

import 'Components/Withdraw/withdraw.style.scss';

class Failure extends React.Component {
  componentDidMount() {
    this.getUserWallets();
    this.getUserWalletsTimer = genericComponentTimer(
      this.getUserWallets,
      30000
    );
  }

  componentWillUnmount() {
    clearInterval(this.getUserWalletsTimer);
  }

  getUserWallets = () => {
    this.props.getUserWallets(this.props.account.access_token);
  };

  getWalletBasedOnSelectedCurrency = (
    wallets,
    walletCurrency,
    activeCurrency
  ) => {
    return _.get(
      _.find(wallets, ['attributes.currency', walletCurrency]),
      `attributes.${activeCurrency}_balance`,
      0
    );
  };

  render() {
    const balance = this.getWalletBasedOnSelectedCurrency(
      this.props.account.user_wallets.wallets,
      this.props.withdraw.type,
      'raw'
    );
    const [integer, float] = transformBalance(
      balance,
      this.props.withdraw.type !== WITHDRAW_TYPE.USDC ? 8 : 2
    );
    return (
      <Container type="page" bgColor="grey-0">
        <GlobalLayout>
          <div className="withdraw-failure-wrapper">
            <div className="failure-header-zone">
              <Icon
                base="regular"
                icon={{ name: 'times-circle', color: 'grey-6' }}
                className="icon"
              />
              <div className="failure-header-content">
                <Text
                  type="h1"
                  textAlign="left"
                  content="withdraw.failure.header"
                  translation
                  className="failure-header"
                />
                <Text
                  type="intro"
                  textAlign="left"
                  content="withdraw.failure.subheader"
                  translation
                  className="failure-text"
                />
              </div>
            </div>
            <div className="failure-general-zone">
              <div>
                <Text
                  type="p"
                  textAlign="left"
                  content="withdraw.failure.content.amount.header"
                  translation
                  className="failure-large-header"
                />
                <Text
                  type="p"
                  textAlign="left"
                  content={`${this.props.withdraw.amount} ${
                    this.props.withdraw.type
                  }`}
                  className="failure-large-text"
                />
              </div>
              <div>
                <Text
                  type="p"
                  textAlign="left"
                  content="withdraw.failure.content.address.header"
                  translation
                  className="failure-header"
                />
                <Text
                  type="p"
                  textAlign="left"
                  content={`${this.props.withdraw.address}`}
                  className="failure-text"
                />
              </div>
              <div>
                <Text
                  type="p"
                  textAlign="left"
                  content="withdraw.failure.content.datetime.header"
                  translation
                  className="failure-header"
                />
                <Text
                  type="p"
                  textAlign="left"
                  content={`${moment(
                    this.props.withdraw.transaction_createdAt
                  ).format('DD.MM.YYYY - HH:mm ([GMT] Z)')}`}
                  className="failure-text"
                />
              </div>
              <div>
                <Text
                  type="p"
                  textAlign="left"
                  content="withdraw.failure.content.currentBalance.header"
                  data={{ type: this.props.withdraw.type }}
                  translation
                  className="failure-header"
                />
                <Text
                  type="p"
                  textAlign="left"
                  content={`${integer}${float} ${this.props.withdraw.type}`}
                  className="failure-text"
                />
              </div>
            </div>
            <div className="failure-action-zone">
              <Button
                content="withdraw.failure.actions.retry"
                translation
                borderColor="orange-3"
                color="orange-3"
                bgColor="white"
                className="button"
                onClick={() => {
                  this.props.withdrawFlowReset();
                }}
              />
              <Link to={APP_ROUTES.DASHBOARD}>
                <Button
                  content="withdraw.failure.actions.dashboard"
                  translation
                  borderColor="orange-3"
                  color="white"
                  bgColor="orange-3"
                  className="button"
                />
              </Link>
            </div>
          </div>
        </GlobalLayout>
      </Container>
    );
  }
}

export default Failure;
